


























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { PulldownItem } from "@/types";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { NumberInput }
})
export default class BasicInfo1 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() ins_type_items!: PulldownItem[]; //保険種類アイテムリスト
  @Prop() ins_multi_items!: PulldownItem[]; //保険併用アイテムリスト
  @Prop() ins_div_items!: PulldownItem[]; //保険区分アイテムリスト
}
